import { render, staticRenderFns } from "./OrderInfoObjectFailedTable.vue?vue&type=template&id=6d678169"
import script from "./OrderInfoObjectFailedTable.vue?vue&type=script&lang=js"
export * from "./OrderInfoObjectFailedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports